import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useLanguage } from "@/i18n/LanguageContext";
import type { TranslationKey } from "@/i18n/translations";

const PartnersSection = () => {
  const { t } = useLanguage();

  const partners = [
    { name: "Partner 1", testimonialKey: "testimonial.1" as TranslationKey, author: "Łukasz Serwicki", roleKey: "testimonial.1.role" as TranslationKey },
    { name: "Partner 2", testimonialKey: "testimonial.2" as TranslationKey, author: "Mikołaj Tomczyk", roleKey: "testimonial.2.role" as TranslationKey },
    { name: "Partner 3", testimonialKey: "testimonial.3" as TranslationKey, author: "Dietrich Raab", roleKey: "testimonial.3.role" as TranslationKey },
    { name: "Partner 4", testimonialKey: "testimonial.4" as TranslationKey, author: "Sergii Tarasenko", roleKey: "testimonial.4.role" as TranslationKey },
    { name: "Partner 5", testimonialKey: "testimonial.5" as TranslationKey, author: "Katarzyna Pawłowska", roleKey: "testimonial.5.role" as TranslationKey },
    { name: "Partner 6", testimonialKey: "testimonial.6" as TranslationKey, author: "Stanisław Zając", roleKey: "testimonial.6.role" as TranslationKey },
  ];

  return (
    <section id="partners" className="py-24 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-accent font-semibold mb-4 uppercase tracking-wider text-sm">{t("partners.label")}</span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">{t("partners.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("partners.description")}</p>
        </div>

        <Carousel opts={{ align: "start", loop: true }} className="w-full max-w-5xl mx-auto">
          <CarouselContent className="-ml-4">
            {partners.map((partner) => (
              <CarouselItem key={partner.name} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <div className="bg-background rounded-2xl p-8 h-full flex flex-col select-none">
                  <svg className="w-10 h-10 text-accent mb-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                  <blockquote className="text-muted-foreground text-lg mb-6 leading-relaxed flex-grow">
                    "{t(partner.testimonialKey)}"
                  </blockquote>
                  <div className="border-t border-border pt-4">
                    <div className="font-semibold text-foreground">{partner.author}</div>
                    <div className="text-sm text-muted-foreground">{t(partner.roleKey)}</div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-12" />
          <CarouselNext className="hidden md:flex -right-12" />
        </Carousel>
      </div>
    </section>
  );
};

export default PartnersSection;
